import { render, staticRenderFns } from "./content-all-v3.vue?vue&type=template&id=97f08270&"
import script from "./content-all-v3.vue?vue&type=script&lang=js&"
export * from "./content-all-v3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "content-all-v3.vue"
export default component.exports